/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
import $ from 'jquery';
import {
    prefix
} from './globals';
import {
    BaseForm,
    EMAIL_REG,
    POSTAL_CODE_REG,
    MESSAGE_REQUIRED, ONLY_LETTER_REG, MESSAGE_ONLY_LETTER, ONLY_NUMBER_REG, MESSAGE_ONLY_NUMBER,
} from './form/BaseForm'

class formGetInvolved extends BaseForm {
    constructor() {
        super();

        this.$form = $(`.${prefix}-get-involved-form`);

        if (this.$form.length === 0)
            return;

        this.init();
    }

    initValidationFields = () => {
        this.fieldsValidation = {
            fullname: {
                $field: this.$fullNameInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: ONLY_LETTER_REG,
                        message: MESSAGE_ONLY_LETTER,
                    },
                ]
            },
            address: {
                $field: this.$addressInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                ]
            },
            postalCode: {
                $field: this.$postalCodeInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: POSTAL_CODE_REG,
                        message: 'The postal code is not valid.',
                    },
                ]
            },
            phone: {
                $field: this.$phoneInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: ONLY_NUMBER_REG,
                        message: MESSAGE_ONLY_NUMBER,
                    },
                ]
            },
            email: {
                $field: this.$emailInput,
                type: 'text',
                rules: [
                    {
                        required: true,
                        message: MESSAGE_REQUIRED
                    },
                    {
                        regex: EMAIL_REG,
                        message: 'Please enter a valid email address.',
                    },
                ]
            },
            age: {
                $field: this.$ageCheckInput,
                type: 'checkbox',
                rules: [
                    {
                        checked: true,
                        message: 'This must be checked.'
                    },
                ]
            },
            ig: {
                $field: this.$igCheckInput,
                type: 'checkbox',
                rules: [
                    {
                        checked: true,
                        message: 'This must be checked.'
                    },
                ]
            }
        };
    }

    init() {
        this.sending = false;
        this.$fullNameInput = this.$form.find('#clf-fgifullname');
        this.$addressInput = this.$form.find('#fgiaddress');
        this.$postalCodeInput = this.$form.find('#fgipostalCode');
        this.$phoneInput = this.$form.find('#fgiphone');
        this.$emailInput = this.$form.find('#fgiemail');
        this.$ageCheckInput = this.$form.find('#age-checked-form');
        this.$igCheckInput = this.$form.find('#get-involved-checked-form');
        this.$submitButton = this.$form.find('#get-involved-submit-form');
        this.$terms = this.$form.find('#fgiterms');

        this.$submitButton.on('click', this.onSubmitButton);
        this.initValidationFields();
        this.assignElementOnlyAllowLetter(this.$fullNameInput);
        this.assignElementOnlyAllowNumber(this.$phoneInput);
        this.onCheckBoxesKeyPressed();
    }

    onSubmitButton = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (this.validateForm()) {
            this.onSubmitForm();
        }

        return false;
    }

    validateCheckbox = (evt) => {
        const $this = $(evt.currentTarget);

        if (!(this.$ageCheckInput.is(':checked') && this.$igCheckInput.is(':checked'))) {
            $('.get-involved-form-error').remove();
        }
    }

    onCheckBoxesKeyPressed = () => {
        const $self = this;
        $("#get-involved-checked-form").keydown(function (event) {
            if (event.keyCode === 13) {
                $self.validateCheckbox();
            }
        });
        $("#age-checked-form").keydown(function (event) {
            if (event.keyCode === 13) {
                $self.validateCheckbox();
            }
        });
    }

    onSubmitForm = () => {
        if (this.sending) return;

        this.sending = true;
        this.$submitButton.after(`<div class="${prefix}-loader">Loading...</div>`);
        this.$submitButton.remove();

        const data = {
            fgiaddress: this.$addressInput.val(),
            fgipostalCode: this.$postalCodeInput.val(),
            fgiphone: this.$phoneInput.val(),
            fgiemail: this.$emailInput.val(),
            fgiterms: this.$terms.text(),
            fgimsg: '',
            'clf-fgifullname': this.$fullNameInput.val(),
        };

        $.ajax({
            type: 'POST',
            url: '/wp-json/clf/v1/email?form=officials_form',
            crossDomain: true,
            data: data,
            success: (data) => {
                this.$form.addClass('hide');
                this.$form.after(
                    '<div class="get-involved-message"><h4>Thank you for subscribing!</h4></div>'
                );
                this.sending = false;
            },
            error: (err) => {
                this.$form.addClass('hide');
                this.$form.after(
                    '<div class="get-involved-message"><h4>Thank you for subscribing!</h4></div>'
                );
                this.sending = false;
            },
        });
    }
}

export default formGetInvolved;
